import React from "react";
import NewsRouter from "./NewsRouter";
import ScrollToTopOnMount from "../../../ScrollToTop";
import PageContainer from "../../common/PageContainer";

export default function News() {
    return (
        <>
            <ScrollToTopOnMount />
            <PageContainer>
                <NewsRouter />
            </PageContainer>
        </>
    );
}
